import { particularTransaction } from '../../../utils/types';
import { getExpectedPaymentSendDate } from '../../../../auth/_requests';
import type { PayRentTransactionDetailPayload } from '../../../utils/payRentTransactionDetailPayload';

export type TransactionData = PayRentTransactionDetailPayload;

export const transformTransactionData = (
  item: particularTransaction
): TransactionData => {
  // Filter out refund status - treat it as faile

  return {
    date: item.timestampAdded || '',
    buildingName: item.buildingName || '',
    transactionId: item.tenantTransactionId || null,
    transactionType: item.transactionType || '', // 'credit' or 'debit'
    paymentType: item.paymentType || '', // 'direct' or 'subscription'
    transactionMethod: item.cardType || null,
    totalAmount: String(item.amountPaid || '0'),
    status: item.status  ,
    tenantBuildingId: item.tenantBuildingId || '',
    cardCompany: item.cardCompany || null,
    cardType: item.cardType || null,
    rentAmount: item.rentAmount || 0,
    processingFee: item.processingFee || 0,
    fixedFee: item.fixedProcessingFee || 0,
    percentageRate: item.percentageRate || 0,
    percentageProcessingFee: item.percentageProcessingFee || 0,
    discountAmount: item.discountAmount || 0,
    paymentMethodName: item.paymentMethodName || '',
    promoCodeDiscountAmount: item.promoCodeDiscountAmount
      ? Number(item.promoCodeDiscountAmount)
      : 0,
    tenantPaymentOptionId: item.tenantPaymentOptionId,
    errorMessages: item.errorMessages ?? null,
    formattedErrorMessage: item.formattedErrorMessage ?? null,
    expectedPaymentSendDate: item.expectedPaymentSendDate ?? null,
  };
};

/** The list API has no send date, so fetch it for successful payments (their status depends on it). */
export const withExpectedPaymentSendDate = (
  token: string | undefined,
  items: TransactionData[]
): Promise<TransactionData[]> =>
  Promise.all(
    items.map(async (item) =>
      item.status?.toLowerCase() === 'success' && item.transactionId
        ? {
            ...item,
            expectedPaymentSendDate: await getExpectedPaymentSendDate(token, item.transactionId),
          }
        : item
    )
  );

export const getNetProcessingFee = (transaction: TransactionData): number => {
  const fee = Number(transaction.processingFee || 0);
  const promoDiscount = Number(transaction.promoCodeDiscountAmount || 0);
  return Math.max(0, fee - promoDiscount);
};

export const getPaymentMode = (
  paymentMethodName: string,
  cardCompany?: string | null,
  cardType?: string | null
): string => {
  if (!paymentMethodName) {
    return 'Unknown payment type';
  }

  const safeCompany = cardCompany?.trim() || '';
  const safeType = cardType?.trim() || '';

  if (paymentMethodName === 'Credit Card') {
    return safeCompany ? `${safeCompany} ${safeType} card`.trim() : 'Credit Card';
  } else if (paymentMethodName === 'Debit Card') {
    return safeCompany ? `${safeCompany} ${safeType} card`.trim() : 'Debit Card';
  } else if (paymentMethodName === 'preAuthorizedDebit') {
    return 'Pre Authorized Debit';
  }

  return paymentMethodName;
};

